import { ValidationErrors } from '../validation/validation-errors';

export class StatusResponse {
  public Status: string;
  public Entity: any;
  public ValidationErrors: ValidationErrors;
}
